export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'MEMBER': 'Member',
            'EVENTS': 'Events',
            'DASHBOARD': 'Dashboard',
            'DEPARTMENTS': 'Departments',
            'LEGALREGULATORY'  : 'Legal & Regulatory',
            'REGISTRATIONREPORT'  : 'Registration Reports'
        }
    }
};
